import React from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import useFetchApiData from "../helper/useFetchApiData";

const PrivacyPolicy = () => {
  const data=useFetchApiData('/config')

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />
      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />
      {/* Preloader */}
      <Preloader />
      {/* HeaderOne */}
      <HeaderOne category={true} />
      {/* Breadcrumb */}
      <Breadcrumb title={"Privacy Policy"} />

      {/* Tabs for Profile, Address, and Orders */}
      <div style={{ padding: "24px", display: "flex" }}>
      <div dangerouslySetInnerHTML={{ __html: data.privacy_policy}}></div>

      </div>
      {/* FooterTwo */}
      <FooterOne />
      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default PrivacyPolicy;
